import React from 'react';
import { Route, Switch } from 'react-router-dom';
import BougthRecord from './BougthRecord';
import MemberList from './MemberList';
import UserPayingMemberList from './UserPayingMemberList';
import PayingMemberPlanList from './PayingMemberPlanList';
import PayingMemberPlan from './PayingMemberPlan';
import Page404 from '../../components/Page404';
import '../../style/components/MemberManagememt/member-management.scss';

const MemberManagement = (props) => {
  return (
    <Switch>
      <Route
        exact
        path={`${props.match.url}/MemberList`}
        component={MemberList}
      />
      <Route
        path={`${props.match.url}/BougthRecord/:id`}
        component={BougthRecord}
      />
      <Route
        exact
        path={`${props.match.url}/UserPayingMemberList`}
        component={UserPayingMemberList}
      />
      <Route
        exact
        path={`${props.match.url}/PayingMemberPlanList`}
        component={PayingMemberPlanList}
      />
      <Route
        path={`${props.match.url}/PayingMemberPlan/:id?`}
        component={PayingMemberPlan}
      />
      <Route component={Page404} />
    </Switch>
  );
};

export default MemberManagement;
